<template>
  <v-dialog v-model="show" persistent max-width="600px">
    <v-card>
      <v-toolbar color="light-green lighten-3" dark>
        <v-toolbar-title class="headline"
          >{{ Info.name }} anpassningsvy</v-toolbar-title
        >
      </v-toolbar>
      <v-card-text>
        <p>
          Här kan du se vilka pedagoger som använder vilka anpassningar för
          {{ Info.name }}, om du är lärare och också använder eller ska testa en
          anpassning så klicka på plustecknet. Har du testat en anpassning som
          inte fungerat eller inte behövs längre, tryck då på minus-tecknet. För
          att lägga till ny anpassning gå då in i ändra.
        </p>
        <v-container>
          <v-flex>
            <v-flex>
              <v-flex
                v-for="(adaptation, index) in locadaptations"
                :key="adaptation[0]"
              >
              <v-flex v-if="(Info.hasOwnProperty('classLevel'))">
<!-- Klassbas -->
  <v-toolbar :color="colors[index] + ' lighten-3'" dark>
                      <v-toolbar-title> {{ adaptation }}</v-toolbar-title>
                    </v-toolbar>
 <v-flex>
                      <h3>Lärare som använder anpassningen:</h3>
                      <template
                        class="xs3"
                        v-for="ID in teacherIds[
                          teacherIds.findIndex((index) => index.adaptation == adaptation)
                        ].teachers"
                      >
                        <v-chip
                          :key="ID + index"
                          v-if="ID != ''"
                          class="ma-2"
                          :color="
                            colors[
                              teachernameandId.findIndex((i) => index[1] == ID)
                            ]
                          "
                          text-color="white"
                        >
                          {{ locfun.getName(ID, teachernameandId, []) }}
                        </v-chip>
</template >


<v-flex v-if="role!='eht'">
      <v-btn v-if="!teacherIds[teacherIds.findIndex(i => i.adaptation==adaptation)].teachers.includes(id)"
      class="mx-2"
      fab
      dark
      color="green"
@click="add(teacherIds.findIndex(i => i.adaptation==adaptation))"
    >
      <v-icon dark>
        add
      </v-icon>
    </v-btn>
          <v-btn v-else
      class="mx-2"
      fab
      dark
      color="orange"
      @click="remove(teacherIds.findIndex(i => i.adaptation==adaptation))"
    >
      <v-icon dark>
        remove
      </v-icon>
    </v-btn>
</v-flex>


</v-flex>

<!-- Elevbasis  -->
              </v-flex>
              <v-flex v-else>
                <v-flex v-if="adaptation.length != 0" >
                  <v-flex v-for="value in adaptation" :key="value">
                    <!-- <h3 color="blue"></h3> -->
                    <v-toolbar :color="colors[index] + ' lighten-3'" dark>
                      <v-toolbar-title> {{ value }}</v-toolbar-title>
                    </v-toolbar>
                    <v-flex>
                      <h3>Lärare som använder anpassningen:</h3>
                      <template
                        class="xs3"
                        v-for="ID in teacherIds[
                          teacherIds.findIndex((i) => i.adaptation == value)
                        ].teachers"
                      >
                        <v-chip
                          :key="ID + index"
                          v-if="ID != ''"
                          class="ma-2"
                          :color="
                            colors[
                              teachernameandId.findIndex((i) => i[1] == ID)
                            ]
                          "
                          text-color="white"
                        >
                          {{ locfun.getName(ID, teachernameandId, []) }}
                        </v-chip>
</template >

<v-flex v-if="role!='eht'">
      <v-btn v-if="!teacherIds[teacherIds.findIndex(i => i.adaptation==value)].teachers.includes(id)"
      class="mx-2"
      fab
      dark
      color="green"
@click="add(teacherIds.findIndex(i => i.adaptation==value))"
    >
      <v-icon dark>
        add
      </v-icon>
    </v-btn>
          <v-btn v-else
      class="mx-2"
      fab
      dark
      color="orange"
      @click="remove(teacherIds.findIndex(i => i.adaptation==value))"
    >
      <v-icon dark>
        remove
      </v-icon>
    </v-btn>
</v-flex>
</v-flex>


            </v-flex>
            </v-flex>
            </v-flex>
            </v-flex>
            </v-flex>

     
          </v-flex>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
                <v-btn color="green lighten-1"  v-if="updated"  text dark @click="change()">
          Uppdatera
        </v-btn>
        <v-btn dark color="red darken-1" v-else @click="show = false"> Stäng </v-btn>
      

      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
export default {
  name: "Moreinfo",

  watch: {},

  computed: {
    show: {
      get() {
        let Ids = [];
        let flatadaptions = [];
        // //console.log(this.Info);
        if (this.Info.hasOwnProperty("classLevel")) {
          // //console.log("Class"+ this.Info.name)
          flatadaptions = this.Info.ClassAdaptations; //Plattar till den
          this.locadaptations = this.Info.ClassAdaptations;
        } else {
          // //console.log("P"+ this.Info.name)

          this.locadaptations = this.adaptations
            .map((it) => it.filter((_) => true))
            .filter((sub) => sub.length); //Tar bort tomma
          this.teacherIds = [];
          flatadaptions = this.adaptations.flat(); //Plattar till den
        }
        for (let i = 0; i < this.Info.teacherIds.length; i++) {
          Ids.push({
            adaptation: flatadaptions[i],
            teachers: this.Info.teacherIds[i].split(","),
          });
          // //console.log(Ids);
        }

        this.teacherIds = Ids;
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },

  props: {
    teachernameandId: Array,
    adaptations: Array,
    schoolId: String,
    Info: Object,
    id: String,
    value: Boolean,
    role: String,
  },
  data() {
    return {
      update: false,
      colors: [
        "orange",
        "green",
        "light-blue",
        "purple",
        "pink",
        "blue",
        "red",
        "amber",
        "yellow",
        "cyan",
        "light-green",
      ],
      teacherIds: [
        "dY3f0ELmaNktKpsI09r4",
        "dY3f0ELmaNktKpsI09r4",
        "dY3f0ELmaNktKpsI09r4",
      ],
      updated: false,
      locadaptations: [],
      locfun: null,
    };
  },
  created() {
    this.locfun = new fun();
  },
  methods: {
    ...mapActions("extra", ["createExtra", "saveExtra"]),
    ...mapActions(["showSuccessSnackbar"]),

    add(index) {
      this.teacherIds[index].teachers.push(this.id);
      this.updated = true;
    },
    remove(index) {
      var item = this.teacherIds[index].teachers.indexOf(this.id);
      this.teacherIds[index].teachers.splice(item, 1);
      this.updated = true;
    },

    change() {
      if (this.updated == true) {
        let teachers = [];
        
        for (let i = 0; i < this.teacherIds.length; i++) {
          let text = "";
          for (let j = 0; j < this.teacherIds[i].teachers.length; j++) {
            if (this.teacherIds[i].teachers[j] != "") {
              text += this.teacherIds[i].teachers[j] + ",";
            }
          }
          text = text.slice(0, text.length - 1);
          teachers.push(text);
        }

        this.Info.teacherIds = teachers;
        // //console.log(this.Info);
        this.saveExtra(this.Info);
        this.showSuccessSnackbar("Uppdaterat!");
        this.updated = false;
      }

      this.show = false;
    },
  },
};
</script>
<style >
</style>